import { render, staticRenderFns } from "./EventUsersAddDialog.vue?vue&type=template&id=84289488&scoped=true&"
import script from "./EventUsersAddDialog.vue?vue&type=script&lang=js&"
export * from "./EventUsersAddDialog.vue?vue&type=script&lang=js&"
import style0 from "./EventUsersAddDialog.vue?vue&type=style&index=0&id=84289488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84289488",
  null
  
)

export default component.exports